import { render, staticRenderFns } from "./Sos.vue?vue&type=template&id=1c6be46c&"
import script from "./Sos.vue?vue&type=script&lang=js&"
export * from "./Sos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports